import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';


const Section = styled.section`
  background: linear-gradient(180deg, ${themeGet('colors.cream')} 0%, ${themeGet('colors.background')} 100%);
  position: relative;
  z-index: 0;
  overflow: hidden;
`;

export const BannerContentWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  min-height: min(860px, 92vh);
  padding: 120px 0 72px;
  align-items: center;
  gap: 64px;
  @media (max-width: 1024px) {
    min-height: 700px;
    gap: 32px;
  }
  @media (max-width: 991px) {
    min-height: auto;
    padding: 104px 0 64px;
  }
  @media (max-width: 600px) {
    padding: 112px 0 56px;
  }
`;

export const BannerContent = styled.div`
  align-self: center;
  flex: 1 1 520px;
  max-width: 650px;
  @media (max-width: 1219px) {
    max-width: 500px;
  }
  @media (max-width: 768px) {
    max-width: 550px;
  }
  @media (max-width: 991px) {
    max-width: 100%;
    text-align: center;
  }
  .banner-title {
    color: ${themeGet('colors.headingColor')};
    font-weight: 700;
    font-size: 60px;
    line-height: 1.12;
    letter-spacing: -0.8px;
    margin-bottom: 23px;
    @media (max-width: 1563px) {
      font-size: 40px;
    }
    @media (max-width: 768px) {
      font-size: 32px;
    }
    @media (max-width: 600px) {
      font-size: 32px;
      line-height: 1.2;
    }
  }
  @media (max-width: 600px) {
    .button-group {
      img {
        max-width: 120px;
      }
    }
  }
`;

export const BannerText = styled.div`
  font-size: 18px;
  line-height: 1.75;
  color: ${themeGet('colors.textColor')};
  max-width: 560px;
  margin-bottom: 30px;
  @media (max-width: 991px) {
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 600px) {
    font-size: 16px;
  }
  > p:last-child {
    margin-bottom: 0;
  }
`;

export const Figure = styled.figure`
  margin: 0;
  flex: 1 1 460px;
  min-width: 0;
  max-width: 620px;
  @media (max-width: 991px) {
    flex-basis: 100%;
    width: min(100%, 470px);
    margin: 0 auto;
    order: 2;
  }
  @media (max-width: 600px) {
    width: min(92%, 340px);
  }
`;

export const HighlightedText = styled.p`
  line-height: 1;
  margin-bottom: 25px;
  margin-top: 0;

  border-radius: 80px;
  padding: 3px 28px 3px 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${themeGet('colors.label', '#02073E')};
  background-color: ${themeGet('colors.white', '#FFF')};
  box-shadow: ${themeGet('colors.cardShadow')};
  display: inline-flex;
  align-items: center;

  @media only screen and (max-width: 767px) {
    margin: 0 0 30px;
    padding: 3px 15px 4px 3px;
  }
  @media (max-width: 500px) {
    padding-left: 5px;
    padding-right: 8px;
  }
  @media (max-width: 400px) {
    padding-left: 8px;
  }

  @media only screen and (max-width: 500px) {
    font-size: 12px;
  }

  strong {
    padding: 6px 8px;
    border-radius: 30px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0;
    color: ${themeGet('colors.white', '#FFF')};
    background-color: ${themeGet('colors.primary', '#FDEF00')};
    margin-right: 10px;
    display: inline-block;
    @media only screen and (max-width: 500px) {
      margin-right: 5px;
      font-size: 9px;
    }
    @media (max-width: 400px) {
      display: none;
    }
  }
`;

export default Section;
